<ng-template #titleTpl>
  <ng-content select="[nz-tab-link]"></ng-content>
</ng-template>
<ng-template #bodyTpl>
  <ng-content></ng-content>
</ng-template>